import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck, Copy, ArrowRight } from "lucide-react";
import AuthShell, { Field, inputCls, SubmitBtn } from "../../components/AuthShell";
import api from "../../lib/api";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [resetToken, setResetToken] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setResetToken(data.reset_token);
      setDone(true);
    } catch { setDone(true); } finally { setLoading(false); }
  };

  return (
    <AuthShell
      title="Reset your password"
      subtitle="We'll send a secure reset link to your email"
      footer={<><ArrowRight size={13} className="inline" /> <Link to="/login" className="text-indigo-600 font-medium hover:underline">Back to sign in</Link></>}
    >
      {!done ? (
        <form onSubmit={submit}>
          <Field label="Email"><input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="you@company.com" /></Field>
          <SubmitBtn loading={loading}>Send reset link</SubmitBtn>
        </form>
      ) : (
        <div className="text-center">
          <div className="w-14 h-14 rounded-full bg-emerald-50 text-emerald-500 flex items-center justify-center mx-auto"><MailCheck size={26} /></div>
          <p className="mt-4 text-gray-700">If an account exists for <b>{email}</b>, a reset link has been sent.</p>
          {resetToken && (
            <div className="mt-5 text-left bg-amber-50 border border-amber-100 rounded-lg p-3">
              <p className="text-xs font-semibold text-amber-700">DEMO MODE (email sending is mocked)</p>
              <p className="text-xs text-gray-500 mt-1">Use this link to set a new password:</p>
              <Link to={`/reset-password?token=${resetToken}`} className="text-sm text-indigo-600 font-medium hover:underline break-all inline-flex items-center gap-1 mt-1">
                Continue to reset <Copy size={12} />
              </Link>
            </div>
          )}
        </div>
      )}
    </AuthShell>
  );
};

export default ForgotPassword;
